
































import Vue from "vue";

export default Vue.extend({
  props: {
    backupContent: Object,
  },
  data() {
    return {
      copied: null,
    };
  },
  methods: {
    hideRestoreData() {
      this.$emit("hideRestoreData");
    },
    async copyToClipBoard() {
      if ((navigator as any).clipboard) {
        (navigator as any).clipboard.writeText(this.backupContent.content);
      } else {
        this.$refs.backupManuscript.select();
        document.execCommand("copy");
      }
      this.copied = true;
      setTimeout(() => (this.copied = null), 2000);
    },
  },
});
